import Img from 'gatsby-image';
import React, { useState } from 'react';
import Carousel, { Modal, ModalGateway } from 'react-images';
import styled from 'styled-components';

// eslint-disable-next-line no-unused-vars
import { PhotoGalleryChildImageSharp } from '../interfaces';
import { Title } from '../styles/CommonStyledComponents';
import { theme } from '../utils/Theme';
import Headline from './headline/Headline';

const modalStyles = {
  blanket: (base: React.CSSProperties) => ({ ...base, zIndex: 1100 }),
  positioner: (base: React.CSSProperties) => ({ ...base, zIndex: 1110 }),
  dialog: (base: React.CSSProperties) => ({ ...base, zIndex: 1120 }),
};

const CustomModalFooter = ({ currentIndex, views }: any) => {
  const activeView = currentIndex + 1;
  const totalViews = views.length;

  if (!activeView || !totalViews) return null;
  return (
    <span>
      {activeView} z {totalViews}
    </span>
  );
};

const carouselStyles = {
  header: (base: React.CSSProperties) => ({ ...base, opacity: 1, transform: 'translateY(0px)' }),
  view: () => ({
    alignItems: 'center',
    display: 'flex ',
    height: '100vh',
    justifyContent: 'center',
  }),
};

interface PhotoGalleryProps {
  photos: PhotoGalleryChildImageSharp[];
  title: string;
  withImages: boolean;
}

export const PhotoGallery = ({ photos, title, withImages }: PhotoGalleryProps) => {
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index: number) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const GalleryContainer = styled.div`
    padding-bottom: 50px;
    img {
      display: block;
      margin: 0 auto;
      transition: opacity 0.2s ease-out;
      :hover {
        opacity: 0.7;
      }
    }
  `;

  const ImagesContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 10px;
    ${theme.mediaQuerySizes.tablet} {
      grid-template-columns: 1fr 1fr;
    }
    ${theme.mediaQuerySizes.phoneLight} {
      grid-template-columns: 1fr;
    }
  `;
  const ImgWrapper = styled.div``;

  const HeadlinePointerCursor = styled(Headline)`
    color: ${theme.colors.green};
    transition: color 0.1s ease-out;

    :hover {
      cursor: pointer;
      color: ${theme.colors.logoGreen};
    }

    ${Title} {
      color: inherit;
    }
  `;

  return (
    <GalleryContainer>
      <ImgWrapper onClick={() => openLightbox(0)}>
        <HeadlinePointerCursor arrowColor="arrowGreen" title={title}></HeadlinePointerCursor>
      </ImgWrapper>
      {withImages ? (
        <ImagesContainer>
          {photos.map((photo: PhotoGalleryChildImageSharp, index: number) => (
            <ImgWrapper onClick={() => openLightbox(index)} key={index}>
              <Img alt="background image" fluid={photo.smallImage || []} />
            </ImgWrapper>
          ))}
        </ImagesContainer>
      ) : null}

      <ModalGateway>
        {viewerIsOpen ? (
          <Modal onClose={closeLightbox} styles={modalStyles} preventScroll={false}>
            <Carousel
              styles={carouselStyles}
              currentIndex={currentImage}
              views={photos.map((photo: PhotoGalleryChildImageSharp) => ({
                caption: title,
                source: photo.bigImage?.src ? photo.bigImage?.src : '',
              }))}
              components={{ FooterCount: CustomModalFooter }}
              formatters={{
                getAltText: () => 'Zdjęcie',
                getNextTitle: () => 'Następne',
                getPrevTitle: () => 'Poprzednie',
                getCloseLabel: () => 'Zamknij',
                getFullscreenLabel: () => 'Pełny ekran',
              }}
            />
          </Modal>
        ) : null}
      </ModalGateway>
    </GalleryContainer>
  );
};
